export default __webpack_public_path__ + "static/media/home-creative-agency-img-09.029fc5fe.jpg";